import { prop, toLower } from 'ramda';
import { MediaType } from '../../constants/MediaType';
import { NextCallData } from '../../utils/NextCallData';
import { SHUTTERSTOCK_DIGITAL_GOODS_ID } from './constants';
import { toError } from './parsers/error';
import { parseFolderId } from './parsers/folder-id';
import { parseItems } from './parsers/items';
export function initItems(settings, http) {
  const nextCallData = new NextCallData();
  function requestItems(folderId, options, query) {
    if (query === void 0) {
      query = null;
    }
    options = options || {};
    options.paging = options.paging || {};
    options.sort = options.sort || {};
    if (nextCallData.isNextCallDataExists(options.paging, query, folderId)) {
      return nextCallData.getPromiseAndReset();
    }
    const {
      mediaType,
      category,
      orientation,
      color
    } = parseFolderId(folderId);
    const requestOptions = {
      per_page: options.paging.size || settings.itemsLimit,
      page: options.paging.cursor || null,
      order: options.sort.field || null,
      category,
      orientation: orientation || null,
      color: color || null,
      language: options.language || null
    };
    if (settings.country) {
      requestOptions.country = settings.country;
    }
    if (query !== null) {
      requestOptions.query = query;
    }
    const url = mediaType === MediaType.Picture ? `${settings.pictureApi}/search` : `${settings.videoApi}/search`;
    const requestPromise = http.get(url, requestOptions, {
      headers: options.headers || {}
    }).then(parseItems).catch(toError);
    return requestPromise;
  }
  function list(folderId, options) {
    const itemsPromise = requestItems(folderId, options, null);
    if (settings.prefetchNextPage) {
      itemsPromise.then(response => {
        if (!response.paging.cursor) {
          return;
        }
        nextCallData.set(response.paging, requestItems(folderId, {
          ...options,
          paging: response.paging
        }, null), null, folderId);
      });
    }
    return itemsPromise;
  }
  function search(folderId, query, options) {
    const itemsPromise = requestItems(folderId, options, query);
    if (settings.prefetchNextPage) {
      itemsPromise.then(response => {
        if (!response.paging.cursor) {
          return;
        }
        nextCallData.set(response.paging, requestItems(folderId, {
          ...options,
          paging: response.paging
        }, query), query, folderId);
      });
    }
    return itemsPromise;
  }
  function prices(options) {
    if (options === void 0) {
      options = {};
    }
    const guids = [SHUTTERSTOCK_DIGITAL_GOODS_ID.VIDEO, SHUTTERSTOCK_DIGITAL_GOODS_ID.PICTURE];
    const skuToMediaType = skuId => toLower(Object.keys(SHUTTERSTOCK_DIGITAL_GOODS_ID).find(key => SHUTTERSTOCK_DIGITAL_GOODS_ID[key] === skuId));
    const url = settings.pricesApi;
    return http.get(`${url}?${guids.map(g => `skuIds=${g}`).join('&')}`, {}, {
      headers: options.headers || {}
    }).then(prop('data')).then(response => response.digitalGoodsPrices.reduce((prev, price) => ({
      ...prev,
      [skuToMediaType(price.skuId)]: {
        priceValue: price.priceValue,
        priceWithTax: price.priceWithTax,
        currencyCode: response.currencySettings.code,
        currencySymbol: response.currencySettings.symbol,
        ...response.currencySettings,
        ...response.taxSettings
      }
    }), {}));
  }
  return {
    list,
    search,
    prices
  };
}